import type { Reducer } from 'redux';

import { getGraphqlApiErrorReason } from '../..';
import type {
  ScheduleAndCreateTeamsMeetingAction,
  ScheduleAndCreateTeamsMeetingFulfilledAction,
} from '../../domains/scheduleAndCreateTeamsMeeting/actions.types';

import type { ScheduleAndCreateTeamsMeetingRequests } from './types';

export type { ScheduleAndCreateTeamsMeetingAction };

const initialState: ScheduleAndCreateTeamsMeetingRequests = {
  lastFulfilledId: undefined,
  error: false,
};

const errorState: ScheduleAndCreateTeamsMeetingRequests = {
  lastFulfilledId: undefined,
  error: true,
};

const reducer: Reducer<ScheduleAndCreateTeamsMeetingRequests, ScheduleAndCreateTeamsMeetingAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'SCHEDULE_AND_CREATE_TEAMS_MEETING.FULFILLED':
      return stateWithFulfilled(state, action);
    case 'SCHEDULE_AND_CREATE_TEAMS_MEETING.RESET_STATUS':
      return initialState;
    case 'SCHEDULE_AND_CREATE_TEAMS_MEETING.REJECTED':
      if (getGraphqlApiErrorReason(action.payload.error) === 'GROUP_INVITE_NOT_ALLOWED') {
        return { ...errorState, isGroupInviteError: true };
      }

      return errorState;
    default:
      return state;
  }
};

const stateWithFulfilled = (
  state: ScheduleAndCreateTeamsMeetingRequests,
  action: ScheduleAndCreateTeamsMeetingFulfilledAction
) => {
  const teamsMeetingId = Object.keys(action.payload.entities.teamsMeetings)[0];

  return {
    ...state,
    lastFulfilledId: teamsMeetingId,
  };
};

export default reducer;
